var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    { attrs: { for: "firstName" } },
    [
      _vm._t("default", function () {
        return [_vm._v(_vm._s(_vm.value))]
      }),
      _vm._v(" "),
      _vm.required
        ? _c("span", { staticClass: "required" }, [_vm._v("*")])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Checkout/Components/Common/FormLabel.vue